export const productRatesTranslationNl = {
    title: "Tarieven",
    singular: "Tarief",
    fields: {
        price: "Prijs",
        date: "Vanaf datum",
    },
};
